import { Perguntas } from "./style";
import Perguntawebp from "../../../../assets/pergunta.webp";

function PerguntasComponent() {
  return (
    <Perguntas id="perguntas">
      <section>
        <div id="todas-perguntas">
          <span id="pense">Pense um pouco sobre isso aqui.. 👇🏼</span>
          <h1>Responda sinceramente, essa é sua realidade?</h1>
          <ul>
            <li><span>Por que somente 5% da população brasileira consegue se comunicar em inglês tendo tantas escolas, cursos e professores</span> propondo levar os alunos ao alto nível de proficiência no idioma?</li>
            <li><span>Tantos cursos online que têm métodos de toda maneira e forma, mas você entende o COMO fazer?</span> COMO chegar ao resultado?</li>
            <li><span>Por quantas escolas, professores particulares e, nos últimos anos, cursos online você já passou?</span> E qual o resultado que continua tendo?</li>
            <li><span>Quanto você já investiu no aprendizado de inglês, em tempo e financeiramente?</span> Você já contabilizou esse investimento ao longo do anos?</li>
            <li><span>Você conseguiria atingir o resultado sozinho?</span> Será que você tem o que é preciso para chegar ao resultado?</li>
          </ul>
        </div>
        <figure>
          <img src={Perguntawebp} alt="" />
        </figure>
      </section>
    </Perguntas>
  );
}

export default PerguntasComponent;
